import { TaxationReportingEntityConfig } from '@app/modules/taxation/taxation-reporting/presets/taxation-reporting-entity-config.model';
import { RequestState }                  from '@core/interfaces/api.interface';
import { AvailabilityStatusColorEnum }   from '@core/interfaces/common.interfaces';
import {
	BaseEntityExtension,
	IActionItem,
	IBaseEntityUi
}                                        from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }         from '@models/entity.model';


// ENUMS #######################################################################
// API enums *******************************************************************
export enum TaxationReportingFormTypeEnum {
	AO146A = 'ao146a'
}

export enum TaxationReportingStatusEnum {
	ACKNOWLEDGED = 'acknowledged',
	CREATING = 'creating',
	EXPIRED = 'expired',
	OUTDATED = 'outdated',
	PREVIEW_FAILED = 'previewFailed',
	READY = 'ready',
	SUBMIT_FAILED = 'submitFailed',
	SUBMITTING = 'submitting',	// CONFIRMED in DTO model
	SUCCESS = 'success'
}

// UI enums ********************************************************************
export enum TaxationReportingPresetEnum {
	BULK_ACKNOWLEDGE = 'bulkAcknowledge',
	BULK_DOWNLOAD = 'bulkDownload',
	BULK_SUBMIT = 'bulkSubmit',
	BUSINESS_PREMISES_DETAILS_TAXATION_REPORTING = 'businessPremisesDetailsTaxationReporting',
	TAXATION_REPORTING = 'taxationReporting'
}

export enum TaxationReportingTagEnum {
	IS_DOWNLOADED = 'isDownloaded'
}

export enum TaxationReportingErrorsEnum {
	// Unspecific or DF-related
	ERIC_AO146a_0003_emptyField = 'ERIC_AO146a_0003_emptyField',
	ERIC_AO146a_0004_stringMaxLength = 'ERIC_AO146a_0004_stringMaxLength',
	ERIC_AO146a_0005_stringMinLength = 'ERIC_AO146a_0004_stringMinLength',
	ERIC_AO146a_0006_numberMinValue = 'ERIC_AO146a_0006_numberMinValue', // too few digits
	ERIC_AO146a_0007_numberMaxValue = 'ERIC_AO146a_0007_numberMaxValue', // too many digits
	ERIC_AO146a_0008_numberMinValue = 'ERIC_AO146a_0008_numberMinValue', // value is too low
	ERIC_AO146a_0009_numberMaxValue = 'ERIC_AO146a_0009_numberMaxValue', // value is too high
	ERIC_AO146a_0010_invalidCharacter = 'ERIC_AO146a_0010_invalidCharacter',
	ERIC_AO146a_0011_invalidData = 'ERIC_AO146a_0011_invalidData',
	ERIC_AO146a_0012_generalError = 'ERIC_AO146a_0012_generalError',
	ERIC_AO146a_1013 = 'ERIC_AO146a_1013', // street for DF missing
	ERIC_AO146a_1014 = 'ERIC_AO146a_1014', // postal code for DF missing
	ERIC_AO146a_1015 = 'ERIC_AO146a_1015', // city for DF missing
	ERIC_AO146a_1028 = 'ERIC_AO146a_1028', // house number for DF missing

	// Organization
	ERIC_AO146a_0001_invalidVatId = 'ERIC_AO146a_0001_invalidVatId',
	ERIC_AO146a_0002_invalidTaxNumber = 'ERIC_AO146a_0002_invalidTaxNumber',
	ERIC_AO146a_1002 = 'ERIC_AO146a_1002', // no taxpayer info
	ERIC_AO146a_1003 = 'ERIC_AO146a_1003', // contradictory legal form entry (NP vs. others)
	ERIC_AO146a_1004 = 'ERIC_AO146a_1004', // org ID missing
	ERIC_AO146a_1005 = 'ERIC_AO146a_1005', // salutation for NP missing
	ERIC_AO146a_1006 = 'ERIC_AO146a_1006', // last name of NP missing
	ERIC_AO146a_1007 = 'ERIC_AO146a_1007', // first name of NP missing
	ERIC_AO146a_1008 = 'ERIC_AO146a_1008', // birthdate of NP missing
	ERIC_AO146a_1009 = 'ERIC_AO146a_1009', // both econ ID and tax number are filled
	ERIC_AO146a_1010 = 'ERIC_AO146a_1010', // company name missing
	ERIC_AO146a_1011 = 'ERIC_AO146a_1011', // legal form missing
	ERIC_AO146a_1012 = 'ERIC_AO146a_1012', // address missing
	ERIC_AO146a_1016 = 'ERIC_AO146a_1016', // address data inconsistent(?)
	ERIC_AO146a_1017 = 'ERIC_AO146a_1017', // street missing
	ERIC_AO146a_1018 = 'ERIC_AO146a_1018', // postal code missing
	ERIC_AO146a_1019 = 'ERIC_AO146a_1019', // city missing
	ERIC_AO146a_1020 = 'ERIC_AO146a_1020', // country missing
	ERIC_AO146a_1027 = 'ERIC_AO146a_1027', // tax number missing
	ERIC_AO146a_1029 = 'ERIC_AO146a_1029', // house number missing
	ERIC_AO146a_1081 = 'ERIC_AO146a_1081', // birthdate of NP is in future

	// Business Premises
	ERIC_AO146a_1021 = 'ERIC_AO146a_1021', // number of ERSes missing
	ERIC_AO146a_1022 = 'ERIC_AO146a_1022', // decommission date of BP missing
	ERIC_AO146a_1026 = 'ERIC_AO146a_1026', // number of active ERSes does not equal number of ERSes
	ERIC_AO146a_1046 = 'ERIC_AO146a_1046', // street missing
	ERIC_AO146a_1047= 'ERIC_AO146a_1047', // house number missing
	ERIC_AO146a_1048 = 'ERIC_AO146a_1048', // postal code missing
	ERIC_AO146a_1049 = 'ERIC_AO146a_1049', // city missing
	ERIC_AO146a_1080 = 'ERIC_AO146a_1080', // deactivation date is in future
	ERIC_AO146a_1083 = 'ERIC_AO146a_1083', // No ERS present on this Business Premises

	// TSS
	ERIC_AO146a_1057 = 'ERIC_AO146a_1057', // serial number missing
	ERIC_AO146a_1062 = 'ERIC_AO146a_1062', // BSI ID missing
	ERIC_AO146a_1070 = 'ERIC_AO146a_1070', // value 'other' is denied for device type

	// ERS
	ERIC_AO146a_1001 = 'ERIC_AO146a_1001', // duplicate serial number
	ERIC_AO146a_1024 = 'ERIC_AO146a_1024', // activation date predates acquisition date
	ERIC_AO146a_1025 = 'ERIC_AO146a_1025', // deactivation date predates activation date
	ERIC_AO146a_1050 = 'ERIC_AO146a_1050', // device type missing
	ERIC_AO146a_1053 = 'ERIC_AO146a_1053', // software missing
	ERIC_AO146a_1054 = 'ERIC_AO146a_1054', // serial number missing
	ERIC_AO146a_1055 = 'ERIC_AO146a_1055', // brand missing
	ERIC_AO146a_1056 = 'ERIC_AO146a_1056', // model missing
	ERIC_AO146a_1063 = 'ERIC_AO146a_1063', // acquisition date missing
	ERIC_AO146a_1066 = 'ERIC_AO146a_1066', // license plate data for taximeter etc. missing
	ERIC_AO146a_1067 = 'ERIC_AO146a_1067', // license plate data minimum 3 chars
	ERIC_AO146a_1069 = 'ERIC_AO146a_1069', // value 'other' is denied for device type
	ERIC_AO146a_1075 = 'ERIC_AO146a_1075', // acquisition date is in future
	ERIC_AO146a_1076 = 'ERIC_AO146a_1076', // activation date is in future
	ERIC_AO146a_1077 = 'ERIC_AO146a_1077', // deactivation date is in future
	ERIC_AO146a_1079 = 'ERIC_AO146a_1079', // TSS connection date is in future
	ERIC_AO146a_1082 = 'ERIC_AO146a_1082', // TSS connection date is missing
}

export enum TaxationReportingErrorsGroupEnum {
	BUSINESS_PREMISES = 'businessPremises',
	ERS = 'ers',
	ORGANIZATION = 'organization',
	TSS = 'tss',
	UNSPECIFIC = 'unspecific',
}


// INTERFACES ##################################################################
// API interfaces **************************************************************
// UI interfaces ***************************************************************
export interface ITaxationReportingEntityActionEvent {
	action: EntityActionEventEnum;
	taxationReporting: TaxationReporting;
	taxationReportingEntityConfig: TaxationReportingEntityConfig;
}

export interface ITaxationReportingEntityActions {
	acknowledge?: IActionItem;
	download?: IActionItem;
	submit?: IActionItem;
}

export interface ITaxationReportingEntityEvents extends BaseEntityExtension, IBaseEntityUi {
	availabilityStatusColor?: AvailabilityStatusColorEnum;

	/**
	 * Either deadline for submission or deadline for acknowledgement
	 * (depends on status)
	 */
	daysLeftUntilDelete?: number;
	entityActions?: Partial<Record<TaxationReportingEntityActionProp, IActionItem>>;
	isInGracePeriod?: boolean;
}


// TYPES #######################################################################
export type TaxationReportingEntityActionProp = ( keyof ITaxationReportingEntityActions );
export type TaxationReportingEntityActionProps = TaxationReportingEntityActionProp[];

export type TaxationReportingProp = ( keyof TaxationReporting );
export type TaxationReportingProps = TaxationReportingProp[];

export type TaxationReportingStatusUpdate =
	TaxationReportingStatusEnum.ACKNOWLEDGED |
	TaxationReportingStatusEnum.SUBMITTING;

// ENTITIES ####################################################################
export class TaxationReportingTMO {
	public acknowledgedBy?: string = undefined;
	public acknowledgedDate?: Date = undefined;
	public businessPremisesId: string = undefined;
	public businessPremisesName: string = undefined;
	public confirmedBy?: string = undefined;
	/**
	 * Date and time at which the actual submission of the Taxation Reporting was
	 * triggered
	 */
	public confirmedDate?: Date = undefined;
	public createdBy?: string = undefined;
	/**
	 * Date and time at which the creation of the Taxation Reporting was triggered
	 */
	public createdDate?: Date = undefined;
	/**
	 * Date and time at which a SUCCESS-status ("phase-2") Taxation Protocol would
	 * expire
	 * --> consequence: submission pdf will be deleted with no mercy
	 */
	public expireDate?: Date = undefined;
	public failures: TaxationReportingFailures[] = undefined;
	public formType: TaxationReportingFormTypeEnum = undefined;
	public id: string = undefined;
	public isDownloaded?: boolean = undefined;
	public lastModifiedBy?: string = undefined;
	public lastModifiedDate?: Date = undefined;
	/**
	 * Date and time at which the creation of the Taxation Reporting was finished
	 * successfully, and the submission preview PDF is available for download
	 */
	public previewDate?: Date = undefined;
	/**
	 * Date and time at which a READY-status ("phase-1") Taxation Protocol would
	 * expire
	 * --> consequence legally: mandatory reporting was not done in time
	 * --> consequence technically: probably preview pdf will be deleted with no mercy
	 */
	public previewExpireDate?: Date = undefined;
	public status: TaxationReportingStatusEnum = undefined;
	/**
	 * Date and time at which the actual submission was finished successfully,
	 * and the submission protocol is available for download
	 */
	public submissionDate?: Date = undefined;
}

export class TaxationReportingFailuresTMO {
	public code?: string = undefined;
	public message?: string = undefined;
}

export class TaxationReportingMandateConfirmTMO {
	public agreeTerms?: boolean = undefined;				// confirmation modal config: mandate
	public dataConfirmation?: boolean = undefined;	// confirmation modal config: data
	public isAuthorized?: boolean = undefined;			// confirmation modal config: taxpayer
	public storeProtocol?: boolean = undefined;			// confirmation modal config: proceduralDocumentation
}

export class TaxationReporting extends TaxationReportingTMO {
	public etag?: string = undefined;
	public isSelected?: boolean = undefined;
	public ui?: ITaxationReportingEntityEvents = {
		availabilityStatusColor: undefined,
		daysLeftUntilDelete: undefined,
		entityActions: {
			acknowledge: {
				isEnabled: false,
				showLoader: false
			},
			download: {
				isEnabled: false,
				showLoader: false
			},
			submit: {
				isEnabled: false,
				showLoader: false
			}
		},
		isInGracePeriod: undefined,
		requestState: RequestState.NOT_ASKED,
		requestError: undefined
	};
}

export class TaxationReportingFailures extends TaxationReportingFailuresTMO {}

export class TaxationReportingMandateConfirm extends TaxationReportingMandateConfirmTMO {}
